import {
  styled as muiStyled,
  CircularProgress,
  Divider,
  Stack,
  TextField,
} from '@mui/material';

import { COLORS } from '../../../../../../themes/colors';

export const SearchContainer = muiStyled(Stack)(() => ({
  flexDirection: 'column',
}));

export const DividerStyled = muiStyled(Divider)(() => ({
  color: `${COLORS.GRAY['-8']}`,
  width: '100%',
  margin: '0 auto',
  marginTop: '14px',
}));

export const FormWrapper = muiStyled(Stack)(() => ({
  width: '100%'
}));

export const InputSearch = muiStyled(TextField)(() => ({
  flex:1,
  borderColor: `${COLORS.PRIMARY.BLUE['-4']}`,
  color: `${COLORS.PRIMARY.BLUE['-4']}`,
  width: 328,
  alignSelf: 'center',
  fontFamily: 'Work Sans',
}));

export const Container = muiStyled(Stack)(() => ({
  overflowY: 'scroll',
  overflowX: 'hidden',
  height: '250px',
  paddingTop: 12,
}));

export const LoaderWrapper = muiStyled(Stack)(() => ({
  overflow: 'hidden',
}));

export const LoadingStyled = muiStyled(CircularProgress)(() => ({
  color: `${COLORS.PRIMARY.BLUE['-4']}`,
  margin: 'auto',
  width: '100%',
  display: 'block',
}));
